import React, { useEffect, useRef } from "react";
import { version } from "../../../package.json";
import { getCountryName } from "../../utils/helpers";
import "./labels.scss";

const useSvg = image => {
  const svgWrapperRef = useRef();
  useEffect(() => {
    svgWrapperRef.current.innerHTML = image;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    svgWrapperRef
  };
};

export default function SingleLabel({
  stop,
  organisation,
  billingDetails,
  qrSvg
}) {
  const { svgWrapperRef } = useSvg(qrSvg);

  const billingAddress = billingDetails
    ? `${
        billingDetails.address_line1 ? billingDetails.address_line1 + "," : ""
      } 
      ${billingDetails.address_line2 ? billingDetails.address_line2 + "," : ""}
      ${billingDetails.postal_code ? billingDetails.postal_code + "," : ""}
      ${billingDetails.city ? billingDetails.city : ""}`
    : "";

  return (
    <table
      className="tg"
      style={{ tableLayout: "fixed", width: "100mm", height: "150mm" }}
    >
      <colgroup>
        <col style={{ width: "10%" }} />
      </colgroup>
      <thead>
        <tr>
          <th className="tg-5qt9" colSpan="2">
            <span style={{ fontWeight: "bold" }}>From</span>
            <br />
            <span style={{ fontWeight: "normal" }}>
              {`${organisation.name}${
                billingAddress.trim() ? `, ${billingAddress}` : ""
              }`}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="tg-u71t" rowSpan="2">
            <span style={{ fontWeight: "bold" }}>To</span>
          </td>
          <td className="tg-ccdw">
            <span
              className="tg-ccdw"
              //  th:text="${deliveryName}"
            >
              {stop.information.recipient_name}
            </span>
            <br />
            {/* <span
              className="tg-ccdw"
              //  th:text="${deliveryContactName}"
            >
              {}
            </span> */}
            {/* <br /> */}
            <span
              className="tg-ccdw"
              //  th:text="${deliveryAddress}"
            >
              {stop.information.street}
            </span>
            <br />
            <span
              className="tg-ccdw"
              //  th:text="${deliveryAddress2}"
            >
              {stop.information.zipcode} {stop.information.city}
            </span>
            <br />
            <span
              className="tg-ccdw"
              //  th:text="${deliveryZipCode}"
            >
              {getCountryName(stop.information.country)}
            </span>
            <br />
            <span
              className="tg-ccdw"
              //  th:text="${deliveryCity}"
            >
              {" "}
            </span>
            <br />
            <span
              className="tg-ccdw"
              //  th:text="${deliveryRegion}"
            >
              {" "}
            </span>
            <br />
            <span
              className="tg-ccdw"
              //  th:text="${deliveryCountry}"
            >
              {" "}
            </span>
          </td>
        </tr>
        <tr>
          <td className="tg-5qt9">
            Reference: <br />{" "}
            <span
            //  th:text="${reference}"
            >
              {stop.units[0]?.note || ""}
            </span>
          </td>
        </tr>
        <tr>
          <td className="tg-0lax" colSpan="2">
            <span className="qr-wrapper" ref={svgWrapperRef}></span>
            <br />
            <span>{stop.units[0] ? stop.units[0].id : stop.id}</span>
            {stop.units[0] && stop.units[0].name && (
              <>
                <br />
                <span>{stop.units[0] ? stop.units[0].name : ""}</span>
              </>
            )}
            <br />
            <span>{stop.tracking?.id ? stop.tracking.id : ""}</span>
            <br />
            <br />
            Routetitan.com
            <br />
            Label version: 1.0.0
            <br />
            Web App version: {version}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
